import Swiper from 'swiper'

export default class Slider {
  constructor() {
    this.slider = [...document.querySelectorAll('.article__content-slider')];
  }

  initSwiper (slider) {
    const sliderActive = slider.querySelector('.article__content-slider__slide__counter--active')
    const sliderLength = slider.querySelector('.article__content-slider__slide__counter--length')

    const mySwiper = new Swiper(slider, {
      effect: 'fade',
      watchOverflow: true,
      containerModifierClass: 'article__content-slider-',
      wrapperClass: 'article__content-slider__layers',
      slideClass: 'article__content-slider__slide',
      slideActiveClass: 'article__content-slider__slide_active',
      navigation: {
        nextEl: '.article__content-slider__button_next',
        prevEl: '.article__content-slider__button_prev'
      },
      pagination: {
        el: '.article__content-slider__paging-wrap',
        type: 'bullets',
        bulletElement: 'div',
        clickable: true,
        bulletClass: 'article__content-slider__paging__dot',
        bulletActiveClass: 'active'
      }
    })

    // sliderLength.innerHTML = mySwiper.slides.length
    // sliderActive.innerHTML = mySwiper.activeIndex + 1

    // mySwiper.on('slideChange', () => {
    //   sliderActive.innerHTML = mySwiper.activeIndex + 1
    // })
  }

  build () {
    this.slider.forEach(slider => {
      this.initSwiper(slider)
    })
  }

  init() {
    this.build()
  }
}
